import { Avatar } from '@mui/material';

interface Props {
    size?: number;
}

export const Logo = ({ size }: Props) => (
    <Avatar src="/logo192.png" alt="logo" variant="square" sx={{ width: size, height: size }} />
);
